// ==============================|| DEFAULT THEME - TYPOGRAPHY  ||============================== //

const Typography = (fontFamily) => ({
	htmlFontSize: 16,
	fontFamily,
	fontWeightLight: 300,
	fontWeightRegular: 400,
	fontWeightMedium: 500,
	fontWeightBold: 700,
	h1: {
		fontWeight: 400,
		fontSize: '3.5rem',
		// lineHeight: 1.21,
	},
	h2: {
		fontWeight: 400,
		fontSize: '3rem',
		// lineHeight: 1.27,
	},
	h3: {
		fontWeight: 400,
		fontSize: '2.5rem',
		// lineHeight: 1.33,
	},
	h4: {
		fontWeight: 600,
		fontSize: '2rem',
		// lineHeight: 1.4,
		fontFamily: fontFamily
	},
	h5: {
		fontWeight: 600,
		fontSize: '1.5rem',
		// lineHeight: 1.5,
		fontFamily: fontFamily
	},
	h6: {
		fontWeight: 600,
		fontSize: '1.25rem',
		// lineHeight: 1.57,
		fontFamily: fontFamily
	},
	caption: {
		fontWeight: 400,
		fontSize: '0.85rem',
		lineHeight: 1.66
	},
	body1: {
		fontSize: '0.8rem',
		lineHeight: 1.57
	},
	body2: {
		fontSize: '0.85rem',
		lineHeight: 1.66
	},
	subtitle1: {
		fontSize: '1rem',
		fontWeight: 600,
		lineHeight: 1.57
	},
	subtitle2: {
		fontSize: '0.85rem',
		fontWeight: 600,
		lineHeight: 1.66
	},
	overline: {
		fontSize: '0.85rem',
		lineHeight: 1.66
	},
	button: {
		fontSize: '1rem',
		textTransform: 'capitalize'
	}
});

export default Typography;
